<template>
  <div class="praise cursor" :class="{ 'whl-hand-up': type === 3}" @click="clickAnim">
    <img src="/static/lottie/praise/images/point.png" v-show="hide && type!=3">
  </div>
</template>

<script>
import lottie from "lottie-web-limi";
export default {
  name: "praise",
  data() {
    return {
      interval: null,
      canClick:true,
      hide:true
    };
  },
  props: {
    type: {
      default: 0,
      type: Number
    }
  },
  mounted() {
    this.$nextTick(this.animInit);
  },
  methods: {
    animInit() {
      let jsonPath = "/static/lottie/praise/a.json";
      if (this.type === 2) {
        jsonPath = "/static/lottie/encourage/a.json";
      } else if(this.type === 3) {
        jsonPath = '/static/lottie/handup/a.json';
      }
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".praise"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: false,
        path: jsonPath
      });
      //将元素添加到DOM时
      this.anim.addEventListener("DOMLoaded", this.domLoaded);
      //动画执行完成
      this.anim.addEventListener("complete", this.animEnd);
      // this.anim.addEventListener("enterFrame", (w)=>{
      //   console.log(w)
      // });
    },
    domLoaded() {
      this.anim.play();
      if(this.type===3)return;
      //超时未点击播放解释动画
      this.interval = setTimeout(() => {
        this.hide=false;
        this.anim.goToAndPlay(9000);
        // console.log('超时未点击')
      }, 5600);
    },
    animEnd() {
      if (this.anim) {
        this.anim.removeEventListener("complete", this.animEnd);
        this.anim.removeEventListener("DOMLoaded", this.domLoaded);
        this.anim.destroy();
        this.anim = null;
      }
      this.canClick = true;
      clearTimeout(this.interval);
      this.$emit("close", { type: this.type });
    },
    clickAnim() {
      if(!this.canClick)return;
      this.canClick = false;
      clearTimeout(this.interval);
      if (this.type === 3) {
        this.anim.playSegments([230,240], true)
        this.$root.eventHub.$emit("hand_up", {});
      }else {
        this.hide=false;
        this.anim.goToAndPlay(6000);
        setTimeout(()=>{
          this.anim.pause();
          this.animEnd();
        },2900)
      }
    }
  },
  beforeDestroy() {
    this.animEnd();
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.praise {
  width: 345px;
  height: 315px;
  right: 210px;
  bottom: 80px;
  position: absolute;
  z-index: 81;
    img {
      position: absolute;
      left: 183px;
      bottom: 15px;
      width: 60px;
      height: 65px;
      display: block;
      overflow: hidden;
      z-index: 81;
      animation: rotate 1.3s cubic-bezier(0.645, 0.045, 0.150, 1) infinite;
      transform-origin: bottom right;
    }
}
.whl-hand-up {
  width: 360px;
  height: 360px;
  z-index: 999999990;
}

@keyframes rotate {
    0%{
        transform: rotate(0deg);
    }
    50%{
        transform: rotate(10deg);
    }   
    100%{
        transform: rotate(0deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/praise.vue